import React, { memo } from 'react';
import styles from './CarFinance.module.scss';

export const Disclaimer = memo(() => {
  return (
    <div className={styles.disclaimerText}>
      <strong>Disclaimer :</strong>
      {` Interest rates by banks represents
        the best possible rate, which is subjected to change as per CIBIL
        score and preventive lending history of the customer`}
    </div>
  );
});

Disclaimer.displayName = 'Disclaimer';
